import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPSixFoldSignificatorPlanetView ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Six Fold Significators - Planet View');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/extendedplanetsignificator/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );
  }, [userData]);

  const tdwidth = {
    width: "13%",
  };

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
          <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Six-Fold Significators - Planet View</h5></caption>
          <thead>
            <tr class="p-0 m-0">
              <th class="m-0 p-1 kptable-td">Planet</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>A</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>B</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>C</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>D</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>E</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>F</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>G</th> 
            </tr>
          </thead>
          <tbody>
            {chartData.map((planet) => (
                  <tr class="p-0 m-0"  onClick={handleClickColor}>
                      <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[0]}</th>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[2]}</td>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[3]}</td>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[4]}</td>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[5]}</td>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[6]}</td>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[7]}</td>
                      <td class="bg-transparent text-center p-0 kptable-td">{planet[8]}</td>
                  </tr>
              ))}
          </tbody>  
          </table>
          <span class="m-0 p-0 kpfont">
          A - Planet Sub Lord's Cuspal Number<br/>
          B - Planet Star Lord's Cuspal Number<br/>
          C - Planet's Cuspal Number<br/>
          D - Planet's Sub Lord as Cuspal's Sign Lord<br/>
          E - Planet's Star Lord as Cuspal's Sign Lord<br/>
          F - Planet as Cuspal's Sign Lord<br/>
          G - Planet as Cuspal's Sub Lord<br/>
          </span>
          </>
          )
        }
        </>
      );
  }